import React from 'react';
import { configureCache } from '@growthbook/growthbook'
import { GrowthBook, GrowthBookProvider } from '@growthbook/growthbook-react'
import { useEffect } from 'react'
import { useSelector } from 'react-redux'

configureCache({
  // The localStorage key the cache will be stored under
  cacheKey: 'growthTalisisFeaturesCache',
  // Consider features stale after this much time (60 seconds default)
  staleTTL: 1000 * 60,
  // Cached features older than this will be ignored (24 hours default)
  maxAge: 1000 * 60 * 60 * 24,
  // For Remote Eval only - limit the number of cache entries (~1 entry per user)
  maxEntries: 10,
  // Set to `true` to completely disable both in-memory and persistent caching
  disableCache: false
})

const growthBook = new GrowthBook({
  apiHost: "https://growth-proxy.talisis.com",
  clientKey: process.env.REACT_APP_TOKEN_GROWTHBOOK,
  enableDevMode: true,
  trackingCallback: (experiment, result) => {
    // This is where you would send an event to your analytics provider
    console.log("Viewed Experiment", {
      experimentId: experiment.key,
      variationId: result.key
    });
  },
  disableCache: false,
  enabled: true
});

export default function GrowthbookProvider({ children }) {

  const { spin_company_id } = useSelector(state => state.spinPremiaReducer)


  useEffect(() => {
    // Create a GrowthBook instance
    // Load features asynchronously when the app renders
    void growthBook.init({
      streaming: true,
      timeout: 2000,
      skipCache: true
    })
      .catch(err => {
        console.error(err)
        err.name = 'Error al inicializar growthbook'
      })
  }, [])

  useEffect(() => {
    void growthBook.setAttributes({
      spin_company_id
    })
      .then(() => {
      })
  }, [spin_company_id])
  return (
    <GrowthBookProvider growthbook={growthBook}>
      {children}
    </GrowthBookProvider>
  )
}
